<div class="md-form md-outline mb-0 mt-3">
  <textarea [ngModel]="server.url" (ngModelChange)="onUrl($event)" id="form-url" class="form-control textarea form-{{color}}" rows="1" type="text" mdbInput style="resize:none;"></textarea>
  <label for="form-url">{{ 'URL' | translate }}</label>
  <small id="form-url-help" class="form-text text-muted d-flex align-items-center">
    <i *ngIf="server.isValid('url')" class="{{color}}-text fas fa-check-circle pr-1"></i>
    <i *ngIf="!server.isValid('url')" class="text-warning fas fa-times-circle pr-1"></i>
    <span class="mr-auto">{{server.url.length}}/{{server.requirement('url').maxLength}} ({{ 'MINIMUM' | translate }}: {{server.requirement('url').minLength}})</span>
  </small>
</div>